import type { FaireProductEntity } from "../../entity_types/product";

export const p_883gs34p33: FaireProductEntity = {
  token: "p_883gs34p33",
  type: "product",
  name: "Finn Charm Necklace | 18 inch",
  brandToken: "b_47o708b9ht",
  brandName: "THATCH",
  imageUrl:
    "https://cdn.faire.com/fastly/257d57812fe126b0dd65f117281c81a34ff777c95917585717721958f4ec4b50.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ca3edb84f6828943d83acf5871613fd797492f57c225f907bdfdffba9f931bc2.jpeg",
  ],
  priceDollars: 36,
  description:
    "A minimalist link chain necklace in two lengths with a center hinge clip that fits all THATCH charms and pendants.",
  tags: [],
  msrpDollars: 80,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:44.876Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
